import * as React from 'react';

import SalePrintResult from '../containers/sales/SalePrintResult';
import BaseSaleHistoryLayout from "~/apps/pos/mobile/pages/BaseSaleHistoryLayout";


export default function () {
  return (
    BaseSaleHistoryLayout(
      <SalePrintResult />
    )
  );
};
